import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, memo } from 'react';
import { attempt } from 'lodash-es';
import useAxis from '../UseAxis';
var AxisTitle = memo(function (_ref) {
  var text = _ref.children,
      axisId = _ref.axisId,
      restProps = _objectWithoutProperties(_ref, ["children", "axisId"]);

  var axis = useAxis(axisId);
  useEffect(function () {
    if (axis) {
      updateAxisTitle(_objectSpread({
        text: text
      }, restProps), axis);
    }
  });
  useEffect(function () {
    return function () {
      if (axis) attempt(updateAxisTitle, {
        text: null
      }, axis);
    };
  }, [axis]);
  return null;
});

var updateAxisTitle = function updateAxisTitle(config, axis) {
  axis.setTitle(config, true);
};

AxisTitle.displayName = 'AxisTitle';
export default AxisTitle;